import { classNames, twMerge } from '@panwds/tailwindcss';
import { getHoverAnimationClasses } from '../NavItemV3/navItemV3.logic.js';
/** Collapse button classes */
export const collapseV3Classes = {
    button: {
        base: 'twds-h-9 twds-items-center twds-cursor-pointer twds-flex twds-group',
        background: 'twds-bg-transparent',
        spacing: 'twds-mb-2 twds-mt-1',
        border: 'twds-border-0 hover:twds-rounded hover:twds-border-steel-gray-700'
    },
    icon: {
        root: {
            base: 'twds-w-5 twds-h-5 twds-flex twds-items-center twds-justify-center twds-flex-shrink-0',
            spacing: 'twds-ml-2',
            border: 'twds-border twds-border-solid twds-rounded-full twds-border-steel-gray-400 group-hover:twds-border-steel-gray-100',
            zIndex: 'twds-z-10'
        },
        caretLeft: {
            base: 'twds-inline-block twds-flex teds-items-center twds-box-border twds-z-10',
            fill: ' twds-fill-steel-gray-400 group-hover:twds-fill-steel-gray-100'
        }
    },
    label: {
        textColor: 'twds-text-steel-gray-400 group-hover:twds-text-steel-gray-100',
        font: 'twds-font-lato twds-font-normal',
        size: 'twds-text-xs',
        spacing: 'twds-ml-4',
        textOverflow: 'twds-truncate',
        zIndex: 'twds-z-10',
        flex: 'twds-flex twds-items-center twds-w-full twds-h-full'
    }
};
export function getCollapsedButtonClasses(collapsed, className) {
    return twMerge(collapseV3Classes.button.base, collapseV3Classes.button.background, collapseV3Classes.button.spacing, collapseV3Classes.button.border, !collapsed ? 'twds-mx-2' : 'twds-ml-2', ...getHoverAnimationClasses(false, collapsed), className);
}
export function getIconClasses() {
    return classNames(collapseV3Classes.icon.root.base, collapseV3Classes.icon.root.spacing, collapseV3Classes.icon.root.border, collapseV3Classes.icon.root.zIndex);
}
export function getCaretLeftIconClasses() {
    return classNames(collapseV3Classes.icon.caretLeft.base, collapseV3Classes.icon.caretLeft.fill);
}
export function getLabelClasses() {
    return classNames(collapseV3Classes.label.textColor, collapseV3Classes.label.font, collapseV3Classes.label.size, collapseV3Classes.label.spacing, collapseV3Classes.label.textOverflow, collapseV3Classes.label.zIndex, collapseV3Classes.label.flex);
}
//# sourceMappingURL=collapse.logic.js.map